import { observer } from 'mobx-react-lite';
import PreviewImageElement from './PreviewImageElement';
import type { PreviewImageElementProps } from './types';

export type { PreviewImageElementProps };
export default observer(PreviewImageElement);
